<template>
    <component
        :is="isExternal ? 'a' : 'router-link'"
        class="underline text-sky-700 hover:text-sky-900 focus-visible:outline-offset-2 focus-visible:outline-2 active:text-sky-600 cursor-pointer"
        v-bind="isExternal ? { href: props.to as string } : { to: props.to }"
        :target="target"
    >
        <slot />
    </component>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { RouteLocationRaw } from 'vue-router';
import { isExternalLink } from '../../helpers/isExternalLink';

type TextLinkProps = {
    to: RouteLocationRaw;
    target?: '_blank';
};

const props = defineProps<TextLinkProps>();
const isExternal = computed(() => isExternalLink(props.to));

// Default to _blank for external links
const target = computed(() => props.target ?? (isExternal.value ? '_blank' : undefined));
</script>
